import React from 'react';

const Account = React.lazy(() => import('views/account').then(m => ({ default: m.Account })));
const Upgrade = React.lazy(() => import('views/account/upgrade').then(m => ({ default: m.Upgrade })));
const Subscribed = React.lazy(() => import('views/account/billing/subscribed'));
const ConfirmPlanUpdate = React.lazy(() => import('views/account/billing/confirm_plan_update'));

const Routes = [
  {
    path: '/account',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Your Account',
  },
  {
    path: '/account/profile',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Your Profile',
  },
  {
    path: '/account/workspace',
    view: Account,
    layout: 'app',
    permission: 'admin',
    title: 'Workspaces',
  },
  {
    path: '/account/whitelabel',
    view: Account,
    layout: 'app',
    permission: 'admin',
    title: 'Whitelabel',
  },
  {
    path: '/account/integration',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Integrations',
  },
  {
    path: '/account/integration/:integrationName',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Your Integrations',
  },
  {
    path: '/account/ai-settings',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'AI Settings',
  },
  {
    path: '/account/unsubscribed',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Manage Unsubscribed Leads',
  },
  {
    path: '/account/settings',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Manage Settings',
  },
  {
    path: '/account/billing',
    view: Account,
    layout: 'app',
    permission: 'admin',
    title: 'Billing',
  },
  {
    path: '/account/billing/:id/confirm',
    view: ConfirmPlanUpdate,
    layout: 'app',
    permission: 'admin',
    title: 'Billing',
  },
  {
    path: '/account/upgrade',
    view: Upgrade,
    layout: 'app',
    permission: 'admin',
    title: 'Upgrade',
  },
  {
    path: '/account/users',
    view: Account,
    layout: 'app',
    permission: 'admin',
    title: 'Users',
  },
  // {
  //   path: '/account/apikeys/*',
  //   view: Account,
  //   layout: 'app',
  //   permission: 'developer',
  //   title: 'API Keys',
  // },
  {
    path: '/subscribed',
    view: Subscribed,
    layout: 'app',
    permission: 'admin',
    title: 'Subscribed',
  },
];

export default Routes;
